import { render } from "./Claim_1_approvedBillList.vue?vue&type=template&id=48072c6f&scoped=true&ts=true"
import script from "./Claim_1_approvedBillList.vue?vue&type=script&lang=ts"
export * from "./Claim_1_approvedBillList.vue?vue&type=script&lang=ts"

import "./Claim_1_approvedBillList.vue?vue&type=style&index=0&id=48072c6f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48072c6f"]])

export default __exports__